export class UtilValidator {

  public static checkNumberKeyDown(e: any) {
    if (e.keyCode >= 48 && e.keyCode <= 57 ||
      e.keyCode >= 96 && e.keyCode <= 105) {
      return true;
    }

    if (e.keyCode == 8 || // backspace
      e.keyCode == 37 || // left
      e.keyCode == 39 || // right
      e.keyCode == 9) // tab
    {
      return true;
    } else {
      return false;
    }
  }

  public static checkPhoneNumberKeyDown(e: any) {
    if (e.keyCode >= 48 && e.keyCode <= 57 ||
      e.keyCode >= 96 && e.keyCode <= 105) {
      return true;
    }

    if (e.keyCode == 8 || // backspace
      e.keyCode == 37 || // left
      e.keyCode == 39 || // right
      e.keyCode == 9 || // tab
      e.keyCode == 107 || e.keyCode == 187) // +
    {
      return true;
    } else {
      return false;
    }
  }
}
